import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TourComponent } from './tour.component';
import { TourPopoverComponent } from './tour-popover.component';
import { TourOutletComponent } from './tour-outlet.component';
import { TourSuggestionsComponent } from './tour-suggestions.component';
import { TourManagementComponent } from './tour-management/tour-management.component';
import { UiElementsModule } from '../elements/ui-elements.module';

// Export services for convenience
export { TourService } from './tour.service';
export { RecommendedTourService } from './recommended-tour.service';
export { TourActionExecutorService } from './tour-action-executor.service';

@NgModule({
  declarations: [
    TourComponent,
    TourOutletComponent,
    TourPopoverComponent,
    TourSuggestionsComponent,
    TourManagementComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UiElementsModule
  ],
  exports: [
    TourComponent,
    TourOutletComponent,
    TourSuggestionsComponent,
    TourManagementComponent
  ]
})
export class TourModule { }
